import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { UserAuth } from "../context/AuthContext";
import { useTranslation } from "../hooks/useTranslation";
import GoogleButton from "react-google-button";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { user, logIn } = UserAuth();
  const navigate = useNavigate();
  const { googleSignIn } = UserAuth();
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await logIn(email, password);
      //navigate("/");
    } catch (error) {
      console.log(error);
      setError(error.message);
    }
  };

  const handleGoogleSignIn = async () => {
    try {
      await googleSignIn();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (user != null) {
      navigate("/account");
    }
  }, [user]);

  return (
    <div className="w-full h-screen">
      <video
        className="hidden sm:block absolute w-full h-full object-cover"
        autoPlay
        muted
        loop
        loading="lazy"
      >
        <source src="./www.grownasspizzaparty.com.webm" type="video/webm" />
        <source src="./www.grownasspizzaparty.com.mp4" type="video/mp4" />
        <img
          src="./background.jpg"
          alt="iSiLIVE Banner"
          className="hidden sm:block absolute w-full h-full object-cover"
        />
      </video>
      <div className="bg-black/60 fixed top-0 left-0 w-full h-screen"></div>
      <div className="fixed w-full px-4 py-24 z-50">
        <div className="max-w-[450px] h-[600px] mx-auto bg-black/85 text-white">
          <div className="max-w-[320px] mx-auto py-16">
            <h1 className="text-3xl font-bold">{t("loginTitle")}</h1>
            {error ? (
              <p className="p-2 mt-1 bg-red-500">{t("loginError")}</p>
            ) : null}
            <form onSubmit={handleSubmit} className="w-full flex flex-col py-4">
              <input
                onChange={(e) => setEmail(e.target.value)}
                className="p-3 my-2 bg-gray-700 rounded"
                type="email"
                placeholder={t("email")}
                autoComplete="email"
              />
              <input
                onChange={(e) => setPassword(e.target.value)}
                className="p-3 my-2 bg-gray-700 rounded"
                type="password"
                placeholder={t("password")}
                autoComplete="current-password"
              />
              <button className="bg-green-800 py-3 my-6 rounded font-bold">
                {" "}
                {t("signIn")}{" "}
              </button>
              <div className="flex justify-between items-center text-sm text-gray-600">
                <p>
                  <input className="mr-2" type="checkbox" />
                  {t("rememberMe")}
                </p>
                <p>
                  <Link to="/forgot-password">{t("resetPassword")}</Link>
                </p>
              </div>
              <p className="py-8">
                <span className="text-gray-600"> {t("newToiSiLive")}</span>{" "}
                <Link to="/signup">{t("signUp")}</Link>
                <h3 className="text-md text-gray-600"> {t("signingInNote")}</h3>
              </p>
            </form>
            <GoogleButton onClick={handleGoogleSignIn} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
